export default "__VITE_ASSET__1e_5jV$f__"